import React from 'react';

const TyCMessage = ({ classes, urlLandingPage, idCountry }) => {
  const Message = (
    <p className={classes.tos_text}>
      Al registrarme declaro que acepto los{' '}
      <a
        href={`${urlLandingPage}/terminos-y-condiciones`}
        className={classes.tos_text_link}
        target="_blank"
        rel="noreferrer"
      >
        términos y condiciones
      </a>{' '}
      y las{' '}
      <a
        href={`${urlLandingPage}/politicas-de-privacidad`}
        className={classes.tos_text_link}
        target="_blank"
        rel="noreferrer"
      >
        políticas de privacidad
      </a>{' '}
      de Empretienda.
    </p>
  );

  const MessageCol = (
    <p className={classes.tos_text}>
      Al registrarme declaro que conozco y acepto los{' '}
      <a
        href={`${urlLandingPage}/terminos-y-condiciones`}
        className={classes.tos_text_link}
        target="_blank"
        rel="noreferrer"
      >
        Términos y Condiciones,
      </a>{' '}
      así como la{' '}
      <a
        href={`${urlLandingPage}/autorizacion-datos-personales`}
        className={classes.tos_text_link}
        target="_blank"
        rel="noreferrer"
      >
        Autorización para el Tratamiento de Datos Personales de Empretienda
      </a>{' '}
    </p>
  );

  return idCountry !== 'COL' ? Message : MessageCol;
};

export { TyCMessage };
